import { useEffect, useState } from "react";
import { api, formatApiError } from "@/api/client";
import { StatusBadge, PriorityBadge } from "@/components/Badges";
import { fmtDateTime } from "@/lib/constants";

export default function EngineerHistory() {
  const [tickets, setTickets] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => { (async () => {
    try { const r = await api.get("/tickets"); setTickets(r.data); } catch (e) { setErr(formatApiError(e)); }
  })(); }, []);

  const done = tickets.filter((t) => ["completed", "closed", "cancelled"].includes(t.status));

  return (
    <div className="px-4 py-4">
      <header className="mb-4">
        <p className="label-eyebrow text-primary">History</p>
        <h1 className="mt-1 font-heading text-2xl font-bold">Past jobs</h1>
      </header>
      {err && <div className="mb-3 rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-xs text-destructive">{err}</div>}
      <div className="space-y-2">
        {done.map((t) => (
          <div key={t.id} className="sharp-card p-3">
            <div className="mb-1 flex items-center justify-between">
              <span className="font-mono text-[11px] text-muted-foreground">{t.ticket_no}</span>
              <PriorityBadge priority={t.priority} />
            </div>
            <p className="text-sm font-medium">{t.complaint}</p>
            <div className="mt-1 flex items-center justify-between">
              <p className="text-[11px] text-muted-foreground">{t.customer?.company_name}</p>
              <StatusBadge status={t.status} />
            </div>
            <p className="mt-1 text-[10px] text-muted-foreground">{fmtDateTime(t.created_at)}</p>
          </div>
        ))}
        {done.length === 0 && <p className="text-sm text-muted-foreground">No completed jobs yet.</p>}
      </div>
    </div>
  );
}
